import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { countryList } from '../../../utils/constants/utility';
import { MatDialog } from '@angular/material/dialog';
import { SearchListComponent } from '../../address/search-list/search-list.component';
import { countryReference } from 'src/app/utils/constants/strings';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { AddressService } from '../../address/service/address/address.service';
import { getCountryNameByCountryCode, postalCodePatternValidation } from 'src/app/utils/utils';

@Component({
  selector: 'app-shipper',
  templateUrl: './shipper.component.html',
  styleUrls: ['./shipper.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ShipperComponent implements OnInit, OnChanges {
  @Input() shipmentForm: FormGroup;
  @Input() isShipPostalValidated: boolean;
  @Input() shipmentStatus: string;
  @Input() countryCode: string;

  CountryCode: string;
  shipCountrylist = [];
  filteredCountry = countryReference;
  shipCityList = [];
  isShipPostalCodeReq: boolean;
  isShipPostalCodeValid: boolean = true;
  isShipCityValid: boolean = true;
  validPostalCodeCityname: string;
  @Output() myShipUpdatedStatus = new EventEmitter<boolean>();
  constructor(private dialog: MatDialog, private addressService: AddressService) {}

  ngOnInit() {
    this.shipCountrylist = countryList;
    this.shipCountrySearchInitialise();
    this.shipCitySearchInitialise();
    this.shipPinCodeSearchInitialise();
  }

  ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes) {
      if (changes.hasOwnProperty(propName)) {
        switch (propName) {
          case 'shipmentStatus':
            this.shipmentStatus = String(changes[propName].currentValue);
            break;

          case 'countryCode':
            if (this.countryCode) {
              this.shipCitySearchInitialise();
              this.shipPinCodeSearchInitialise();
            }
            break;
        }
      }
    }
  }

  shipCountrySearchInitialise() {
    this.shipmentForm
      .get('shipperDetails')
      .get('shipperCountryName')
      .valueChanges.subscribe(newValue => {
        this.shipCountrylist = this.filteredCountry.filter(
          value => value?.name.toLowerCase().indexOf(newValue?.trim().toLowerCase()) === 0
        );
      });
  }

  shipCitySearchInitialise() {
    this.shipmentForm.controls.shipperDetails
      .get('shipperCityName')
      .valueChanges.pipe(debounceTime(1500), distinctUntilChanged())
      .subscribe(newValue => {
        if (!this.shipmentStatus.includes('Manifest')) {
          const currCity = this.shipCityList.some(con => con.city == newValue.trim());
          if (!currCity) {
            if (newValue.trim().length >= 3) {
              this.addressService
                .getPostalCodeServiceableArea(
                  this.shipmentForm.get('shipperDetails').get('shipperCountryCode').value,
                  newValue.trim(),
                  ''
                )
                .subscribe((response: any) => {
                  const currCountryCode = this.shipmentForm
                    .get('shipperDetails')
                    .get('shipperCountryCode').value;

                  if (currCountryCode !== undefined) {
                    this.isShipPostalCodeReq = this.shipCountrylist.find(
                      con => con.code === currCountryCode.toUpperCase()
                    ).isPostalCodeServiceAvailable;
                  }

                  if (!this.isShipPostalCodeReq) {
                    this.shipmentForm.get('shipperDetails').get('shipperPostalCode').setValue('');
                    this.shipmentForm.get('shipperDetails').get('shipperPostalCode').disable();
                  } else {
                    this.shipmentForm.get('shipperDetails').get('shipperPostalCode').enable();
                  }

                  this.shipCityList = response?.postalLocationList;

                  if (this.shipCityList.length > 0) {
                    if (
                      this.shipmentForm.get('shipperDetails').get('shipperCityName').value != ''
                    ) {
                      this.isShipCityValid =
                        this.shipCityList.some(con => con.city == newValue.trim().toUpperCase()) ||
                        this.validPostalCodeCityname.trim().toUpperCase() ==
                          newValue.trim().toUpperCase();

                      const statusVal = this.isShipCityValid && this.isShipPostalCodeValid;
                      this.myShipUpdatedStatus.emit(statusVal);
                    }
                  } else {
                    this.isShipCityValid = false;
                    const statusVal = this.isShipCityValid && this.isShipPostalCodeValid;
                    this.myShipUpdatedStatus.emit(statusVal);
                  }
                });
            }
          } else {
            this.isShipCityValid = true;
            const statusVal = this.isShipCityValid && this.isShipPostalCodeValid;
            this.myShipUpdatedStatus.emit(statusVal);
          }
        }
      });
  }

  shipPinCodeSearchInitialise() {
    this.shipmentForm.controls.shipperDetails
      .get('shipperPostalCode')
      .valueChanges.pipe(debounceTime(1500), distinctUntilChanged())
      .subscribe(newValue => {
        if (!this.shipmentStatus.includes('Manifest')) {
          if (
            this.shipmentForm.get('shipperDetails').get('shipperCountryCode').value == 'CA' ||
            this.shipmentForm.get('shipperDetails').get('shipperCountryCode').value == 'GB'
          ) {
            newValue = postalCodePatternValidation(
              this.shipmentForm.get('shipperDetails').get('shipperCountryCode').value,
              newValue
            );
          }
          const currPostalCode = this.shipCityList.some(con => con.postalCode == newValue.trim());
          if (!currPostalCode) {
            if (newValue.trim().length >= 3) {
              this.addressService
                .getPostalCodeServiceableArea(
                  this.shipmentForm.get('shipperDetails').get('shipperCountryCode').value,
                  '',
                  newValue.trim()
                )
                .subscribe((response: any) => {
                  this.shipCityList = response?.postalLocationList;

                  if (this.shipCityList.length > 0) {
                    if (
                      this.isShipPostalCodeReq &&
                      this.shipmentForm.get('shipperDetails').get('shipperPostalCode').value != ''
                    ) {
                      this.isShipPostalCodeValid = this.shipCityList.some(
                        con => con.postalCode == newValue.trim()
                      );
                      const statusVal = this.isShipCityValid && this.isShipPostalCodeValid;
                      this.myShipUpdatedStatus.emit(statusVal);
                    }
                  } else {
                    this.isShipPostalCodeValid = false;
                    const statusVal = this.isShipCityValid && this.isShipPostalCodeValid;
                    this.myShipUpdatedStatus.emit(statusVal);
                  }
                  //find city name corresponding to valid postal code
                  if (this.isShipPostalCodeValid) {
                    this.validPostalCodeCityname = this.shipCityList.find(
                      con => con.postalCode == newValue.trim()
                    ).city;
                  }
                });
            }
          } else {
            this.isShipPostalCodeValid = true;
            this.shipCityList = this.shipCityList.filter(
              value => value?.postalCode.indexOf(newValue) === 0
            );
            const statusVal = this.isShipCityValid && this.isShipPostalCodeValid;
            this.myShipUpdatedStatus.emit(statusVal);
          }
        }
      });
  }

  selectionChanged(eventVal: string) {
    if (eventVal != '') {
      this.CountryCode = this.shipCountrylist.find(con => con.name === eventVal).code;
      this.shipmentForm.get('shipperDetails').get('shipperCountryCode').setValue(this.CountryCode);
      this.shipmentForm.get('shipperDetails').get('shipperPostalCode').setValue('');
      this.shipmentForm.get('shipperDetails').get('shipperCityName').setValue('');
      this.shipmentForm.get('shipperDetails').get('shippersuburb').setValue('');
      this.addressService
        .getPostalCodeServiceableArea(
          this.shipmentForm.get('shipperDetails').get('shipperCountryCode').value,
          '',
          ''
        )
        .subscribe((response: any) => {
          this.shipCityList = response?.postalLocationList;
        });
      this.isShipPostalCodeReq = this.shipCountrylist.find(
        con => con.code === this.CountryCode
      ).isPostalCodeServiceAvailable;
      if (!this.isShipPostalCodeReq) {
        this.shipmentForm.get('shipperDetails').get('shipperPostalCode').disable();
        this.isShipPostalCodeValid = true;
      } else {
        this.shipmentForm.get('shipperDetails').get('shipperPostalCode').enable();
      }
    } else {
      this.shipmentForm.get('shipperDetails').get('shipperCountryCode').setValue('');
    }
  }

  openAddress(openedFrom) {
    const dialogRef = this.dialog.open(SearchListComponent, {
      data: {
        openedFrom,
      },
      maxHeight: '70vh',
      maxWidth: '90vw',
    });

    dialogRef.afterClosed().subscribe(result => {
      this.shipmentForm.controls.shipperDetails.patchValue(result?.address_details);

      //TODO : Needs to refined fixed for urgent replace of country
      this.shipmentForm.controls.shipperDetails.patchValue({
        shipperCountryName: getCountryNameByCountryCode(result.address_details.shipperCountryCode)
          .name,
      });

      if (result != '') {
        this.shipmentForm.get('shipperDetails').get('shipperCityName').markAsDirty();
      }
    });
  }

  selectionCityChanged(event, item) {
    this.isShipPostalValidated = true;
    if (!item?.postalCode) {
      this.shipmentForm.get('shipperDetails').get('shipperPostalCode').disable();
      if (event.isUserInput) {
        if (item?.cityDistrict) {
          this.shipmentForm.get('shipperDetails').get('shippersuburb').setValue(item?.cityDistrict);
        }
      }
    } else {
      this.shipmentForm.get('shipperDetails').get('shipperPostalCode').enable();
      if (event.isUserInput) {
        this.shipmentForm.get('shipperDetails').get('shipperPostalCode').setValue(item?.postalCode);
      }
    }
  }

  selectionPincodeChanged(event, item) {
    this.isShipPostalValidated = true;
    if (event.isUserInput) {
      this.shipmentForm.get('shipperDetails').get('shipperCityName').setValue(item?.city);
      this.isShipCityValid = true;
    }
  }
}
